import { Box, Divider, Typography, Container } from "@mui/material";
import { Link, palette } from "@powerdiary/components-library/lib";

import styles from "./DesktopFooter.module.css";

interface DesktopFooterProps {
    enableZandaFooter: boolean;
}

export default function DesktopFooter({ enableZandaFooter }: DesktopFooterProps) {
    return (
        <Container maxWidth="md" sx={{ height: "100%" }}>
            <Box
                className={enableZandaFooter ? styles.container : styles.containerCentered}
                data-test-id="section_desktop_footer"
            >
                {enableZandaFooter && (
                    <Box className={styles.leftSection}>
                        <Box className={styles.logoContainer}>
                            <img
                                src="/images/logo/zanda-neutral.svg"
                                alt="Zanda"
                                data-test-id="image_footer_desktop_zanda"
                            />
                            <Typography variant="paragraphSmallSemiBold" color={palette.neutral["500"]}>
                                zanda
                            </Typography>
                        </Box>

                        <Divider orientation="vertical" sx={{ height: "32px" }} />

                        <Link
                            variant="paragraphExtraSmallRegular"
                            color={palette.neutral["500"]}
                            target="_blank"
                            rel="noopener"
                            href="https://zandahealth.com/"
                            data-test-id="link_heart_smart_health"
                        >
                            The heart of smart health practices
                        </Link>
                    </Box>
                )}

                <Box className={styles.rightSection}>
                    <Link
                        variant="paragraphExtraSmallRegular"
                        href="https://www.zandahealth.com/privacy-policy/"
                        target="_blank"
                        rel="noopener"
                        color={palette.neutral["500"]}
                        data-test-id="link_privacy_desktop"
                    >
                        Privacy
                    </Link>
                    <Divider orientation="vertical" sx={{ height: "32px" }} />
                    <Link
                        variant="paragraphExtraSmallRegular"
                        href="https://www.zandahealth.com/terms-of-use/"
                        target="_blank"
                        rel="noopener"
                        color={palette.neutral["500"]}
                        data-test-id="link_terms_desktop"
                    >
                        Terms of Use
                    </Link>
                </Box>
            </Box>
        </Container>
    );
}
